import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { jqxDataTableComponent } from '../../../../assets/jqwidgets-ts/angular_jqxdatatable';

declare var $:any;
declare var defaultGridEditSettings: any;

@Component({
  selector: 'system-integration',
  templateUrl: './system-integration.component.html',
  styleUrls: ['./system-integration.component.css'],
})

export class SystemIntegrationBranch implements OnInit {

  constructor (private route: ActivatedRoute, private titleService: Title) {}

  ngOnInit(){

    //Set the page title
    this.titleService.setTitle("WiseRisk | System Integration Settings");

    /*<![CDATA[*/
  		var mainNav = "setting-nav";
  		var sideNav = "side-nav-setting-integration";

  		$(document)
  				.ready(
  						function() {
  							//stores source node to mapped node as {"sourcenode1":{mappednode1:true,mappedNode2:ture },"sourcenode2":{} }
  							var linkedGraph = {};
  							// Full MVP will use some client side MVVP framework for less clutter
  							// prepare the data
  							var data = [{
  								'name' : "SunGard",
  								'connectionType' : 'JMS',
  								'messageType1' : "Asset Trade",
  								'messageType2' : "FX Order Recommendation",
  								'dataFormat' : "CSV",
  								'isEnabled' : true,
  								'hostName' : "www.assetarena.sungard.com",
  								'port' : '9991',
  								'messageBlockName1' : "Asset Trade",
  								'messageBlockName2' : "FX Order Recommendation",
  								'isMessageEnabled' : true,
  								'headerRow' : "5",
  								'delimiter' : ','

  							}, {
  								'name' : "LineData",
  								'connectionType' : 'JMS',
  								'messageType1' : "Asset Trade",
  								'messageType2' : "FX Order Recommendation",
  								'dataFormat' : "CSV",
  								'isEnabled' : true,
  								'hostName' : "www.backoffice.linedata.com",
  								'port' : '9999',
  								'messageBlockName1' : "Asset Trade",
  								'messageBlockName2' : "FX Order Recommendation",
  								'isMessageEnabled' : true,
  								'headerRow' : "5",
  								'delimiter' : ','
  							}, {
  								'name' : "CRD",
  								'connectionType' : 'FTP',
  								'messageType1' : "Asset Trade",
  								'messageType2' : "FX Order Recommendation",
  								'dataFormat' : "CSV",
  								'isEnabled' : true,
  								'hostName' : "www.oms.crd.com",
  								'port' : '8888',
  								'messageBlockName1' : "Asset Trade",
  								'messageBlockName2' : "FX Order Recommendation",
  								'isMessageEnabled' : true,
  								'headerRow' : "5",
  								'delimiter' : ','
  							}, {
  								'name' : "Eagle",
  								'connectionType' : 'FTP',
  								'messageType1' : "Asset Trade",
  								'messageType2' : "FX Order Recommendation",
  								'dataFormat' : "CSV",
  								'isEnabled' : true,
  								'hostName' : "www.pace.eagle.com",
  								'port' : '8888',
  								'messageBlockName1' : "Asset Trade",
  								'messageBlockName2' : "FX Order Recommendation",
  								'isMessageEnabled' : true,
  								'headerRow' : "5",
  								'delimiter' : ','
  							}];

  							var sampleDataLocal = {
  								'TS' : {
  									'id' : "1",
  									'srcData' : '5/5/2015 3:33:14.567 PM',
  									'targetData' : "5/5/2015 15:33:14.567",
  								},
  								'EX' : {
  									'id' : "2",
  									'srcData' : 'ABC123',
  									'targetData' : "ABC123",
  								},
  								'ORDERID' : {
  									'id' : "3",
  									'srcData' : 'BOB456',
  									'targetData' : "BOB456",
  								},
  								'ACCT' : {
  									'id' : "4",
  									'srcData' : '5745',
  									'targetData' : "5745",
  								},
  								'SYMB' : {
  									'id' : "5",
  									'srcData' : 'SONY',
  									'targetData' : "SONY",

  								},
  								'EXCH' : {
  									'id' : "6",
  									'srcData' : 'NYSE',
  									'targetData' : "NYSE",

  								},
  								'ATID' : {
  									'id' : "7",
  									'srcData' : 'CAT1',
  									'targetData' : "CAT1",
  								},
  								'DATE' : {
  									'id' : "8",
  									'srcData' : '5/5/2015 ',
  									'targetData' : "5/5/2015 ",
  								},
  								'QTY' : {
  									'id' : "9",
  									'srcData' : 'QTY=100; PX=1.24',
  									'targetData' : "124.00",
  								},
  								'PX' : {
  									'id' : "10",
  									'srcData' : '112',
  									'targetData' : "112",
  								},
  								'SIDE' : {
  									'id' : "11",
  									'srcData' : 'B',
  									'targetData' : "BUY",
  								}
  							};

  							var sampleDataLocal1 = {
  								'Timestamp' : {
  									'id' : "1",
  									'srcData' : '5/5/2015 3:33:14.567 PM',
  									'targetData' : "5/5/2015 15:33:14.567",
  								},
  								'Asset Trade' : {
  									'id' : "2",
  									'srcData' : 'ABC123',
  									'targetData' : "ABC123",
  								},
  								'Account ID' : {
  									'id' : "3",
  									'srcData' : 'BOB456',
  									'targetData' : "BOB456",
  								},
  								'Order ID' : {
  									'id' : "4",
  									'srcData' : '5745',
  									'targetData' : "5745",
  								},
  								'Symbol' : {
  									'id' : "5",
  									'srcData' : 'SONY',
  									'targetData' : "SONY",

  								},
  								'Exchange' : {
  									'id' : "6",
  									'srcData' : 'NYSE',
  									'targetData' : "NYSE",

  								},
  								'Trade Date' : {
  									'id' : "7",
  									'srcData' : 'CAT1',
  									'targetData' : "CAT1",
  								},
  								'Settlement Date' : {
  									'id' : "8",
  									'srcData' : '5/5/2015 ',
  									'targetData' : "5/5/2015 ",
  								},
  								'Quantity' : {
  									'id' : "9",
  									'srcData' : 'QTY=100; PX=1.24',
  									'targetData' : "124.00",
  								},
  								'Price' : {
  									'id' : "10",
  									'srcData' : '112',
  									'targetData' : "112",
  								},
  								'Side' : {
  									'id' : "11",
  									'srcData' : 'B',
  									'targetData' : "BUY",
  								}
  							};
  							var sourceDataLocal = [{
  								'srcField' : 'TS'
  							}, {
  								'srcField' : 'EX'
  							}, {
  								'srcField' : 'ORDERID'
  							}, {
  								'srcField' : 'ACCT'
  							}, {
  								'srcField' : 'SYMB'
  							}, {
  								'srcField' : 'EXCH'
  							}, {
  								'srcField' : 'ATID'
  							}, {
  								'srcField' : 'DATE'
  							}, {
  								'srcField' : 'QTY'
  							}, {
  								'srcField' : 'PX'
  							}, {
  								'srcField' : 'SIDE'
  							}];

  							var source = {
  								localdata : data,
  								datatype : "json",
  								updaterow : function(rowid, rowdata, commit) {
  									commit(true);
  								}
  							};
  							var dataAdapter = new $.jqx.dataAdapter(source);

  							var updatePanel = function(datarecord) {
  								$("#name").val(datarecord.name);
  								$("#isEnabled").prop("checked",datarecord.isEnabled);
  								$("#dataFormat").val(datarecord.dataFormat);
  								$("#messageType1").val(datarecord.messageType1);
  								$("#messageType2").val(datarecord.messageType2);
  								$("#connectionType").val(datarecord.connectionType);
  								$("#hostName").val(datarecord.hostName);
  								$("#port").val(datarecord.port);
  								$("#messageType").val(datarecord.messageType);
  								$("#messageBlockName1").val(datarecord.messageBlockName1);
  								$("#messageBlockName2").val(datarecord.messageBlockName2);
  								$("#isMessageEnabled").prop("checked", datarecord.isMessageEnabled);
  								$("#nameMessageLink1").text(datarecord.messageBlockName1);
  								$("#nameMessageLink2").text(datarecord.messageBlockName2);
  								$("#headerRow").val(datarecord.headerRow);
  								$("#delimiter").val(datarecord.delimiter);
  							}
  							$('#connectorsGrid').on('rowselect', function(event) {
  								updatePanel(event.args.row);
  							});

  							$("#connectorsGrid")
  									.jqxGrid(
  											{
  												width : '100%',
  												height : '100%',
  												theme : 'bootstrap',
  												source : dataAdapter,
  												showfilterrow : true,
  												filterable : true,
  												columnsresize : true,
  												showstatusbar : true,
  												renderstatusbar : function(statusbar) {
  													// appends buttons to the status bar.
  													var container = $("<div style='overflow: hidden; position: relative; margin: 5px;'></div>");
  													var addButton = $("<div style='float: left; margin-left: 5px;'>+</div>");
  													var deleteButton = $("<div style='float: left; margin-left: 5px;'>-</div>");
  													container.append(addButton);
  													container.append(deleteButton);
  													statusbar.append(container);
  													addButton.jqxButton();
  													deleteButton.jqxButton();
  													// add new row.
  													addButton.click(function(event) {
  														var datarow = [{
  															'name' : "",
  															'email' : '',
  															'phone' : "",
  															'password' : "",
  															'timezone' : "",
  															'dateformat' : "",
  															'timeformat' : "",
  															'numberformt' : ""
  														}];
  														$("#connectorsGrid").jqxGrid('addrow', null, datarow[0]);
  														//this is really bad call; I couldn't find better way to do this
  														//using this only for canned demo; we'll never use for large data set.
  														var rowId = $("#connectorsGrid").jqxGrid('getrows').length - 1;
  														// 			                        rowId = $('#jqxgrid').jqxGrid('getrowid',rowId);

  														$('#connectorsGrid').jqxGrid('selectrow', rowId);
  													});
  													// delete selected row.
  													deleteButton.click(function(event) {
  														var selectedrowindex = $("#connectorsGrid").jqxGrid(
  																'getselectedrowindex');
  														var rowscount = $("#connectorsGrid").jqxGrid(
  																'getdatainformation').rowscount;
  														var id = $("#connectorsGrid").jqxGrid('getrowid',
  																selectedrowindex);
  														$("#connectorsGrid").jqxGrid('deleterow', id);
  													});
  												},
  												columns : [{
  													text : 'Connection Name',
  													datafield : 'name',
  													width : '100%'
  												}, ]
  											});

  							updatePanel(data[0]);

  							var cellclass = function(row, datafield, value, rowdata) {
  								return "defaultcellclass";
  							}

  							var sourceData = {
  								localdata : sourceDataLocal,
  								datafields : [{
  									name : 'srcField',
  									type : 'string'
  								}],
  								datatype : "json"
  							};
  							var dataAdapterSource = new $.jqx.dataAdapter(sourceData);
  							// create data grids.

  							$("#sourceGrid")
  									.jqxGrid(
  											{
  												width : '100%',
  												// 				height : '100%',
  												columnsresize : true,
  												source : dataAdapterSource,
  												autoheight : true,
  												showstatusbar : true,
  												// 								editable : true,
  												rendered : function(type) {
  													// select all grid cells.
  													var gridCells = $('#sourceGrid').find('.jqx-grid-cell');
  													// initialize the jqxDragDrop plug-in. Set its drop target to the second Grid.
  													gridCells.jqxDragDrop({
  														appendTo : 'body',
  														dragZIndex : 99999,
  														dropAction : 'none',
  														initFeedback : function(feedback) {
  															feedback.height(25);
  														},
  														dropTarget : $('#targetGrid'),
  														revert : true
  													});
  													gridCells.off('dragStart');
  													gridCells.off('dragEnd');
  													gridCells.off('dropTargetEnter');
  													gridCells.off('dropTargetLeave');
  													// disable revert when the dragged cell is over the second Grid.
  													gridCells.on('dropTargetEnter', function() {
  														gridCells.jqxDragDrop({
  															revert : false
  														});
  													});
  													// enable revert when the dragged cell is outside the second Grid.
  													gridCells.on('dropTargetLeave', function() {
  														gridCells.jqxDragDrop({
  															revert : true
  														});
  													});
  													// initialize the dragged object.
  													gridCells.on('dragStart', function(event) {
  														var value = $(this).text();
  														var position = $.jqx.position(event.args);
  														var cell = $("#sourceGrid").jqxGrid('getcellatposition',
  																position.left, position.top);
  														$(this).jqxDragDrop('data', {
  															value : value
  														});
  													});

  													// set the new cell value when the dragged cell is dropped over the second Grid.
  													gridCells.on('dragEnd', function(event) {
  														var sourceCellValue = $(this).text();
  														var position = $.jqx.position(event.args);
  														var cell = $("#targetGrid").jqxGrid('getcellatposition',
  																position.left, position.top);
  														var targetCellValue = cell.value;

  														if (cell != null) {

  															if (sourceCellValue in linkedGraph) {
  																console.log(linkedGraph);
  																var targetMap = linkedGraph[sourceCellValue];
  																targetMap[targetCellValue] = true;
  															} else {
  																var targetValMap = {};
  																targetValMap[targetCellValue] = true;
  																linkedGraph[sourceCellValue] = targetValMap;
  															}
  															$("#targetGrid")
  																	.jqxGrid('setcellvalue', cell.row, "mapping",
  																			sourceCellValue);

  															var sampleValue = sampleDataLocal[sourceCellValue];
  															var srcValue = sampleValue['srcData'];
  															var targetValue = sampleValue['targetData'];

  															$("#sampleGrid").jqxGrid('setcellvalue', cell.row,
  																	"srcData", srcValue);

  															$("#sampleGrid").jqxGrid('setcellvalue', cell.row,
  																	"targetData", targetValue);

  														}
  													});

  												},
  												selectionmode : 'singlecell',
  												renderstatusbar : function(statusbar) {
  													// appends buttons to the status bar.
  													var container = $("<div style='overflow: hidden; position: relative; margin: 5px;'></div>");
  													var addButton = $("<div style='float: left; margin-left: 5px;'>+</div>");
  													var deleteButton = $("<div style='float: left; margin-left: 5px;'>-</div>");
  													var moveUpButton = $("<div style='float: left; margin-left: 5px;'>&#x2191</div>");
  													var moveDownButton = $("<div style='float: left; margin-left: 5px;'>&#x2193</div>");
  													container.append(addButton);
  													container.append(deleteButton);
  													container.append(moveUpButton);
  													container.append(moveDownButton);
  													statusbar.append(container);
  													addButton.jqxButton();
  													deleteButton.jqxButton();
  													moveUpButton.jqxButton();
  													moveDownButton.jqxButton();

  													// add new row.
  													addButton.click(function(event) {
  														var datarow = [{
  															'srcField' : "",
  														}];
  														$("#sourceGrid").jqxGrid('addrow', null, datarow[0]);
  														//this is really bad call; I couldn't find better way to do this
  														//using this only for canned demo; we'll never use for large data set.
  														var rowId = $("#sourceGrid").jqxGrid('getrows').length - 1;
  														// 			                        rowId = $('#jqxgrid').jqxGrid('getrowid',rowId);

  														$('#sourceGrid').jqxGrid('selectrow', rowId);
  													});
  													// delete selected row.
  													deleteButton
  															.click(function(event) {
  																var selectedrowindex = $("#sourceGrid").jqxGrid(
  																		'getselectedrowindex');
  																var rowscount = $("#sourceGrid").jqxGrid(
  																		'getdatainformation').rowscount;
  																var id = $("#sourceGrid").jqxGrid('getrowid',
  																		selectedrowindex);
  																$("#sourceGrid").jqxGrid('deleterow', id);
  															});
  												},
  												columns : [{
  													text : 'Available Fields',
  													datafield : 'srcField',
  													cellclassname : cellclass,
  													width : '100%'
  												}, ]
  											});
  							$("#sourceGrid").on("cellclick", function(event) {
  								var args = event.args;
  								// row's bound index.
  								var rowBoundIndex = args.rowindex;
  								var cell = $('#sourceGrid').jqxGrid('getcell', rowBoundIndex, "scrField");
  								var value = args.value;

  								if (value in linkedGraph) {
  									console.log(linkedGraph);
  									var srcColId = sampleDataLocal[value].id;
  									var scrollTop = parseInt(event.args.originalEvent.clientX);
  									var scrollLeft = parseInt(event.args.originalEvent.clientY);
  									// 							        alert([scrollTop,scrollLeft]);

  									// 									cellclass = "mappedcellclass";

  									var rowBoundIndex = event.args.rowindex;
  									var c: any;
                    c = document.getElementById("myCanvas");
  									var ctx = c.getContext("2d");
  									c.width = c.width;
  									ctx.strokeStyle = "#0000FF";
  									ctx.moveTo(0, 60 + rowBoundIndex * $('#sourceGrid').jqxGrid('rowsheight'));
  									ctx.lineTo(60, 110);
  									ctx.stroke();
  									// 					renderer.line(scrollTop, scrollLeft, scrollLeft+600, scrollLeft+600, { stroke: 'blue', 'stroke-width': 6 });
  									// 				            renderer.refresh();

  									var targetMap = linkedGraph[value];

  									for ( var data in targetMap) {
  										var targetData = sampleDataLocal1[data];
  										var targetColId = targetData.id;
  									}
  								}

  							});

  							var targetDataLocal = [{
  								'targetField' : 'Timestamp',
  								'mapping' : "",
  								'scripts' : ""
  							}, {
  								'targetField' : 'Asset Trade',
  								'mapping' : "",
  								'scripts' : ""
  							}, {
  								'targetField' : 'Account ID',
  								'mapping' : "",
  								'scripts' : ""
  							}, {
  								'targetField' : 'Order ID',
  								'mapping' : "",
  								'scripts' : ""
  							}, {
  								'targetField' : 'Symbol',
  								'mapping' : "",
  								'scripts' : ""
  							}, {
  								'targetField' : 'Exchange',
  								'mapping' : "",
  								'scripts' : ""
  							}, {
  								'targetField' : 'Side',
  								'mapping' : "",
  								'scripts' : ""

  							}, {
  								'targetField' : 'Quantity',
  								'mapping' : "",
  								'scripts' : ""
  							}, {
  								'targetField' : 'Price',
  								'mapping' : "",
  								'scripts' : ""

  							}, {
  								'targetField' : 'Settlement Date',
  								'mapping' : "",
  								'scripts' : ""
  							}, {
  								'targetField' : 'Trade Date',
  								'mapping' : "",
  								'scripts' : ""
  							}];

  							var targetData = {
  								localdata : targetDataLocal,
  								datafields : [{
  									name : 'targetField',
  									type : 'string'
  								}, {
  									name : 'mapping',
  									type : 'string'
  								}],
  								datatype : "array"
  							};

  							var targetDataAdapterTarget = new $.jqx.dataAdapter(targetData);

  							$("#targetGrid").jqxGrid({
  								width : '100%',
  								selectionmode : 'singlecell',
  								autoheight : true,
  								enabletooltips : true,
  								source : targetDataAdapterTarget,
  								columns : [{
  									text : 'Mapped Fields',
  									dataField : 'mapping',
  									width : '50%'
  								}, {
  									text : 'Available Fields',
  									dataField : 'targetField',
  									cellclassname : cellclass,
  									width : '50%'
  								}, ]
  							});
  							// Sample Grid

  							var sampleData = {
  								localdata : [{
  									'srcData' : '',
  									'targetData' : ""
  								}, {
  									'srcData' : '',
  									'targetData' : "",
  								}, {
  									'srcData' : '',
  									'targetData' : "",
  								}, {
  									'srcData' : '',
  									'targetData' : "",
  								}, {
  									'srcData' : '',
  									'targetData' : "",
  								}, {
  									'srcData' : '',
  									'targetData' : "",
  								}, {
  									'srcData' : '',
  									'targetData' : "",
  								}, {
  									'srcData' : '',
  									'targetData' : "",
  								}, {
  									'srcData' : '',
  									'targetData' : "",
  								}, {
  									'srcData' : '',
  									'targetData' : "",
  								}, {
  									'srcData' : '',
  									'targetData' : "",
  								}],
  								datafields : [{
  									name : 'srcData',
  									type : 'string'
  								}, {
  									name : 'targetData',
  									type : 'string'
  								}],
  								datatype : "array"
  							};

  							var sampleDataAdapterTarget = new $.jqx.dataAdapter(sampleData);

  							$("#sampleGrid").jqxGrid({
  								width : '100%',
  								selectionmode : 'singlecell',
  								autoheight : true,
  								source : sampleDataAdapterTarget,
  								columns : [{
  									text : 'Source',
  									dataField : 'srcData',
  									width : '50%'
  								}, {
  									text : 'Target',
  									dataField : 'targetData',
  									width : '50%'
  								}, ]
  							});

  							$("#messageButton1")
  									.click(
  											function() {
  												if ($('#messageButton1 span').hasClass('glyphicon-menu-down')) {
  													$('#messageButton1')
  															.html(
  																	'<span class="glyphicon glyphicon-menu-up"></span> Hide Details');
  												} else {
  													$('#messageButton1')
  															.html(
  																	'<span class="glyphicon glyphicon-menu-down"></span> Show Details');
  												}
  											});
  							// 							Message Detial Panel2
  							$("#messageButton2")
  									.click(
  											function() {
  												if ($('#messageButton2 span').hasClass('glyphicon-menu-down')) {
  													$('#messageButton2')
  															.html(
  																	'<span class="glyphicon glyphicon-menu-up"></span> Hide Details');
  												} else {
  													$('#messageButton2')
  															.html(
  																	'<span class="glyphicon glyphicon-menu-down"></span> Show Details');
  												}
  											});

  							$("#sourceGridFx")
  									.jqxGrid(
  											{
  												width : '100%',
  												// 				height : '100%',
  												columnsresize : true,
  												source : dataAdapterSource,
  												autoheight : true,
  												showstatusbar : true,
  												// 								editable : true,
  												rendered : function(type) {
  													// select all grid cells.
  													var gridCells = $('#sourceGridFx').find('.jqx-grid-cell');
  													// initialize the jqxDragDrop plug-in. Set its drop target to the second Grid.
  													gridCells.jqxDragDrop({
  														appendTo : 'body',
  														dragZIndex : 99999,
  														dropAction : 'none',
  														initFeedback : function(feedback) {
  															feedback.height(25);
  														},
  														dropTarget : $('#targetGridFx'),
  														revert : true
  													});
  													gridCells.off('dragStart');
  													gridCells.off('dragEnd');
  													gridCells.off('dropTargetEnter');
  													gridCells.off('dropTargetLeave');
  													// disable revert when the dragged cell is over the second Grid.
  													gridCells.on('dropTargetEnter', function() {
  														gridCells.jqxDragDrop({
  															revert : false
  														});
  													});
  													// enable revert when the dragged cell is outside the second Grid.
  													gridCells.on('dropTargetLeave', function() {
  														gridCells.jqxDragDrop({
  															revert : true
  														});
  													});
  													// initialize the dragged object.
  													gridCells.on('dragStart', function(event) {
  														var value = $(this).text();
  														var position = $.jqx.position(event.args);
  														var cell = $("#sourceGridFx").jqxGrid('getcellatposition',
  																position.left, position.top);
  														$(this).jqxDragDrop('data', {
  															value : value
  														});
  													});

  													// set the new cell value when the dragged cell is dropped over the second Grid.
  													gridCells.on('dragEnd', function(event) {
  														var sourceCellValue = $(this).text();
  														var position = $.jqx.position(event.args);
  														var cell = $("#targetGridFx").jqxGrid('getcellatposition',
  																position.left, position.top);
  														var targetCellValue = cell.value;

  														if (cell != null) {

  															if (sourceCellValue in linkedGraph) {
  																console.log(linkedGraph);
  																var targetMap = linkedGraph[sourceCellValue];
  																targetMap[targetCellValue] = true;
  															} else {
  																var targetValMap = {};
  																targetValMap[targetCellValue] = true;
  																linkedGraph[sourceCellValue] = targetValMap;
  															}
  															$("#targetGridFx")
  																	.jqxGrid('setcellvalue', cell.row, "mapping",
  																			sourceCellValue + "->" + targetCellValue);

  															var sampleValue = sampleDataLocal[sourceCellValue];
  															var srcValue = sampleValue['srcData'];
  															var targetValue = sampleValue['targetData'];

  															$("#sampleGridFx").jqxGrid('setcellvalue', cell.row,
  																	"srcData", srcValue);

  															$("#sampleGridFx").jqxGrid('setcellvalue', cell.row,
  																	"targetData", targetValue);

  														}
  													});

  												},
  												selectionmode : 'singlecell',
  												renderstatusbar : function(statusbar) {
  													// appends buttons to the status bar.
  													var container = $("<div style='overflow: hidden; position: relative; margin: 5px;'></div>");
  													var addButton = $("<div style='float: left; margin-left: 5px;'>+</div>");
  													var deleteButton = $("<div style='float: left; margin-left: 5px;'>-</div>");
  													var moveUpButton = $("<div style='float: left; margin-left: 5px;'>&#x2191</div>");
  													var moveDownButton = $("<div style='float: left; margin-left: 5px;'>&#x2193</div>");
  													container.append(addButton);
  													container.append(deleteButton);
  													container.append(moveUpButton);
  													container.append(moveDownButton);
  													statusbar.append(container);
  													addButton.jqxButton();
  													deleteButton.jqxButton();
  													moveUpButton.jqxButton();
  													moveDownButton.jqxButton();

  													// add new row.
  													addButton.click(function(event) {
  														var datarow = [{
  															'srcField' : "",
  														}];
  														$("#sourceGridFx").jqxGrid('addrow', null, datarow[0]);
  														//this is really bad call; I couldn't find better way to do this
  														//using this only for canned demo; we'll never use for large data set.
  														var rowId = $("#sourceGridFx").jqxGrid('getrows').length - 1;
  														// 			                        rowId = $('#jqxgrid').jqxGrid('getrowid',rowId);

  														$('#sourceGridFx').jqxGrid('selectrow', rowId);
  													});
  													// delete selected row.
  													deleteButton.click(function(event) {
  														var selectedrowindex = $("#sourceGridFx").jqxGrid(
  																'getselectedrowindex');
  														var rowscount = $("#sourceGridFx")
  																.jqxGrid('getdatainformation').rowscount;
  														var id = $("#sourceGridFx").jqxGrid('getrowid',
  																selectedrowindex);
  														$("#sourceGridFx").jqxGrid('deleterow', id);
  													});
  												},
  												columns : [{
  													text : 'Available Fields',
  													datafield : 'srcField',
  													cellclassname : cellclass,
  													width : '100%'
  												}, ]
  											});
  							$("#sourceGridFx").on("cellclick", function(event) {
  								var args = event.args;
  								// row's bound index.
  								var rowBoundIndex = args.rowindex;
  								var cell = $('#sourceGridFX').jqxGrid('getcell', rowBoundIndex, "scrField");
  								var value = args.value;

  								if (value in linkedGraph) {
  									console.log(linkedGraph);
  									var srcColId = sampleDataLocal[value].id;

  									// 									cellclass = "mappedcellclass";

  									var targetMap = linkedGraph[value];

  									for ( var data in targetMap) {
  										var targetData = sampleDataLocal1[data];
  										var targetColId = targetData.id;
  									}
  								}

  							});

  							$("#targetGridFx").jqxGrid({
  								width : '100%',
  								selectionmode : 'singlecell',
  								autoheight : true,
  								enabletooltips : true,
  								source : targetDataAdapterTarget,
  								columns : [{
  									text : 'Mapped Fields',
  									dataField : 'mapping',
  									width : '50%'
  								}, {
  									text : 'Available Fields',
  									dataField : 'targetField',
  									cellclassname : cellclass,
  									width : '50%'
  								}, ]
  							});

  							$("#sampleGridFx").jqxGrid({
  								width : '100%',
  								selectionmode : 'singlecell',
  								autoheight : true,
  								source : sampleDataAdapterTarget,
  								columns : [{
  									text : 'Source',
  									dataField : 'srcData',
  									width : '50%'
  								}, {
  									text : 'Target',
  									dataField : 'targetData',
  									width : '50%'
  								}, ]
  							});

  							 // create context menu
  							 var editrow:number = -1;
  							 var data1;
  				            $("#targetGrid").on('celldoubleclick', function (event) {
  				                var args = event.args;
  				                var rowindex = args.rowindex;
  				                    editrow = rowindex;
  				                    var offset = $("#targetGrid").offset();
  				                    $("#popupWindow").jqxWindow({ position: { x: parseInt(offset.left) + 60, y: parseInt(offset.top) + 60} });
  				                    // get the clicked row's data and initialize the input fields.
  				                    var dataRecord = $("#targetGrid").jqxGrid('getrowdata', editrow);


  				                    $("#complexMapping").val(dataRecord.mapping);
  				                    $("#popupWindow").jqxWindow('show');
  				            });

  // 				            $("#jqxgrid").on('rowclick', function (event) {
  // 				                if (event.args.rightclick) {
  // 				                    $("#jqxgrid").jqxGrid('selectrow', event.args.rowindex);
  // 				                    var scrollTop = $(window).scrollTop();
  // 				                    var scrollLeft = $(window).scrollLeft();
  // 				                    contextMenu.jqxMenu('open', parseInt(event.args.originalEvent.clientX) + 5 + scrollLeft, parseInt(event.args.originalEvent.clientY) + 5 + scrollTop);
  // 				                    return false;
  // 				                }
  // 				            });
  				            // initialize the popup window and buttons.
  				            $("#popupWindow").jqxWindow({ width: 350, resizable: false,  isModal: true, autoOpen: false, cancelButton: $("#Cancel"), modalOpacity: 0.01 });
  				            $("#Cancel").jqxButton({ theme: 'bootstrap' });
  				            $("#popupSave").jqxButton({ theme: 'bootstrap' });
  				            // update the edited row when the user clicks the 'Save' button.
  				            $("#popupSave").click(function () {
  				                if (editrow >= 0) {
  				                    var row = { targetField: $("#targetField").val(), mapping: $("#complexMapping").val() };
  				                    var rowid = $("#targetGrid").jqxGrid('getrowid', editrow);
  				                    $('#targetGrid').jqxGrid('updaterow', rowid, row);
  				                    $("#popupWindow").jqxWindow('hide');
  				                }
  				            });

  							$('#jqxTabs').jqxTabs({
  								width : '100%',
  								autoHeight : true
  							});

  							$('#connectorsGrid').jqxGrid('selectrow', 0);

  						});

  		/*]]>*/
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/settings/system-integration/system-integration.component.ts